// Copyright (c) 2017 Deere & Company

import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import actions from '../../action-list';
import filterOptions from '../constants/filter-options';

export const updateListFilterBy = (dealers, filterBy) =>
    dispatch => {

        dispatch({
            data: filterCollection(filterBy, filterOptions, dealers),
            type: actions.UPDATE_LABOR_RATE_DEALERS_FILTERED
        });

        dispatch({
            filterBy,
            type: actions.UPDATE_LABOR_RATE_DEALERS_FILTER_BY
        });

    };

export const updateListSortBy = (dealers, sortBy, sortDirection) =>
    dispatch => {

        dispatch({
            data: sortCollection(sortBy, sortDirection, dealers),
            type: actions.UPDATE_LABOR_RATE_DEALERS_FILTERED
        });

        dispatch({
            sortBy,
            type: actions.UPDATE_LABOR_RATE_DEALERS_SORT_BY
        });

    };

export const updateListSortDirection = (dealers, sortBy, sortDirection) =>
    dispatch => {

        dispatch({
            data: sortCollection(sortBy, sortDirection, dealers),
            type: actions.UPDATE_LABOR_RATE_DEALERS_FILTERED
        });

        dispatch({
            sortDirection,
            type: actions.UPDATE_LABOR_RATE_DEALERS_SORT_DIRECTION
        });

    };



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/action-creators/search-filters.js